import { createFileRoute } from '@tanstack/react-router';

import { UpdatePolicyPage } from '~features/policies/ui/update-policy-page';

export const Route = createFileRoute('/_auth/_layout/policies/$policyId/')({
  component: UpdatePolicyPage,
});
